/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Location_WarehouseInputs */

const en_reference_location_warehouse = /** @type {(inputs: Reference_Location_WarehouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warehouse`)
};

/**
* | output |
* | --- |
* | "Warehouse" |
*
* @param {Reference_Location_WarehouseInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_location_warehouse = /** @type {((inputs?: Reference_Location_WarehouseInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Location_WarehouseInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_location_warehouse(inputs)
});